import { defineStore } from "pinia";
import { useNuxtApp } from "nuxt/app";
export const productStore = defineStore("productStore", {
  state: () => ({
    currentProduct: null,
    products: [],
    recentlyProducts: [],
    relatedProducts: [],
    sameProducts: [],
    pagination: {
      currentPage: 1,
      perPage: 24,
      pageCount: 0,
      totalCount: 0
    },
    loading: false,
    filters: [],
    sort: "default",
    brandSlug: null,
    setSlug: null,
    promotionSlug: null,
    categorySlug: null
  }),
  actions: {
    onClearCurrentProductsStore() {
      this.products = [];
    },
    async getProduct(params) {
      try {
        this.loading = true;
        const {
          $api
        } = useNuxtApp();
        const productRes = await $api.productsApi.getProductBySlug(params);
        this.currentProduct = productRes;
        return productRes;
      } finally {
        this.loading = false;
      }
    },
    async getProducts(params) {
      try {
        this.loading = true;
        const { $api } = useNuxtApp();
        const page = params.currentPage || this.pagination.currentPage || 1;
        const perPage = params.perPage || this.pagination.perPage || 24;
        const filters = params.filters || this.filters || [];
        const sort = params.sort || this.sort || "default";
        const extensions = params.extensions || [];
        const basePath = params?.basePath || "/categories";
        const requestBody = {
          filters,
          currentPage: page,
          perPage,
          sort,
          extensions,
          basePath
        };
        const response = await $api.productsApi.getProducts(params.slug, requestBody);
        const pagination = {
          ...this.pagination,
          ...response.pagination
        };
        if (response.items) {
          let items = [...response.items];
          if (params.isLoadMore) {
            items = [...this.products, ...items];
          }
          if (params.isLoadPrevious) {
            items = [...items, ...this.products];
          }
          this.products = items;
          this.pagination = pagination;
        }
        return response?.items || [];
      } finally {
        this.loading = false;
      }
    },
    async getRelatedProducts(params) {
      try {
        this.loading = true;
        const {
          $api
        } = useNuxtApp();
        const {
          slug,
          extensions
        } = params;
        const productsRes = await $api.productsApi.getRelatedProducts(slug || "", extensions || []);
        this.relatedProducts = productsRes;
        return productsRes;
      } finally {
        this.loading = false;
      }
    },
    async getRecentlyProducts(params) {
      try {
        this.loading = true;
        const {
          $api
        } = useNuxtApp();
        const {
          extensions
        } = params;
        const productsRes = await $api.productsApi.getRecentlyProducts(extensions || []);
        this.recentlyProducts = productsRes;
        return productsRes;
      } finally {
        this.loading = false;
      }
    },
    async getSameProducts(params) {
      try {
        this.loading = true;
        const {
          $api
        } = useNuxtApp();
        const {
          slug,
          extensions
        } = params;
        const productsRes = await $api.productsApi.getSameProducts(slug || "", extensions || []);
        this.sameProducts = productsRes;
        return productsRes;
      } finally {
        this.loading = false;
      }
    }
  },
  getters: {
    getLoadingInState: ({ loading }) => loading,
    getProductsInState: ({ products }) => products,
    getRelatedProductsInState: ({ relatedProducts }) => relatedProducts,
    getSameProductsInState: ({ sameProducts }) => sameProducts,
    getCurrentProductInState: ({ currentProduct }) => currentProduct,
    getRecentlyProductsInState: ({ recentlyProducts }) => recentlyProducts,
    getPageTotalCountInState: ({ pagination }) => pagination.totalCount,
    getPageCountInState: ({ pagination }) => pagination.pageCount,
    getPaginationInState: ({ pagination }) => pagination,
    getSortInPage: ({ sort }) => sort,
    breadcrumbs: ({ currentProduct }) => {
      let depth = 0;
      const breadcrumbs = [
        {
          title: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
          path: "/",
          depth
        }
      ];
      if (currentProduct) {
        let path = "";
        currentProduct.categories.forEach(({ name: title, slug }) => {
          depth++;
          path += `/${slug}`;
          breadcrumbs.push({ title, path, depth });
        });
        breadcrumbs.push({
          title: currentProduct.name || "",
          path: currentProduct.url || "",
          depth: ++depth
        });
      }
      return breadcrumbs;
    }
  }
});
